export default __webpack_public_path__ + "static/media/quiz-result-radio.b02a1017.svg";